import { render, staticRenderFns } from "./NoveltyCampaignSection.vue?vue&type=template&id=7182a8e8&"
import script from "./NoveltyCampaignSection.vue?vue&type=script&lang=ts&"
export * from "./NoveltyCampaignSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports